var _rect, _path, _line, _line2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSketchpadThumbnail = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-background",
    x: 1.00732,
    y: 0.5,
    width: 104.493,
    height: 105,
    rx: 10.5,
    fill: "white",
    stroke: "#1E1E1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-line",
    d: "M105 35.2761L1 35.2761",
    stroke: "#D5D8DD"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "thumbnail-line",
    x1: 36.5049,
    y1: 1,
    x2: 36.5049,
    y2: 105,
    stroke: "#D5D8DD"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "thumbnail-line",
    x1: 72.0171,
    y1: 1,
    x2: 72.0171,
    y2: 105,
    stroke: "#D5D8DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-line",
    d: "M105 73.0942L1 73.0942",
    stroke: "#D5D8DD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88 53C88 72.33 72.33 88 53 88C33.67 88 18 72.33 18 53C18 33.67 33.67 18 53 18C72.33 18 88 33.67 88 53Z",
    fill: "#4C9990"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.091 69.6349C48.7053 69.6349 51.6137 69.8057 51.6137 72.2824C51.6137 74.7591 49.3547 77.3782 45.7404 77.3782C42.1261 77.3782 38.54 74.7306 38.54 72.2824C38.54 69.8341 41.4767 69.6349 45.091 69.6349Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 2.21619,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9528 70.1966C67.0427 70.1966 69.529 70.3427 69.529 72.46C69.529 74.5773 67.5979 76.8163 64.508 76.8163C61.4182 76.8163 58.3525 74.5529 58.3525 72.46C58.3525 70.367 60.863 70.1966 63.9528 70.1966Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.89459,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0547 45.0085C70.0547 48.6228 70.2255 51.5312 72.5883 51.5312C74.9512 51.5312 77.4849 49.2722 77.4849 45.6579C77.4849 42.0436 74.9512 38.4575 72.5883 38.4575C70.2255 38.4575 70.0547 41.3941 70.0547 45.0085Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 0.554047
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8627 74.0069H42.0593C37.0774 74.0069 32.978 69.9408 32.978 64.9993V37.7134C32.978 32.7719 37.0774 28.7058 42.0593 28.7058H61.8627C66.8446 28.7058 70.944 32.7719 70.944 37.7134V64.9993C70.944 69.9408 66.8731 74.0069 61.8627 74.0069Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 0.554047
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3037 74.0069H50.3616C45.3797 74.0069 41.2803 69.9408 41.2803 64.9994V38.4857C41.3087 33.5442 45.3797 29.4781 50.3901 29.4781H66.3322C71.3141 29.4781 75.4135 33.5442 75.4135 38.4857V64.9994C75.385 69.9408 71.3141 74.0069 66.3037 74.0069Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.66214,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9338 51.531H52.2406C48.9384 51.531 46.2339 48.8485 46.2339 45.5731V40.6599C46.2339 37.3844 48.9384 34.7019 52.2406 34.7019H65.9622C69.2645 34.7019 71.969 37.3844 71.969 40.6599V45.6013C71.9405 48.8485 69.2361 51.531 65.9338 51.531Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.66214,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9229 45.2907C64.9229 46.1661 65.6346 46.872 66.5171 46.872C67.85 46.872 69.9696 44.1508 69.9696 42.9925C69.9696 41.1391 67.6529 38.5421 66.5171 38.5421C65.6346 38.5421 64.9229 39.248 64.9229 40.1234V45.2907Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 0.554047
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4301 41.544C68.6727 41.5348 68.8269 41.2844 68.8099 41.0423C68.803 40.9446 68.7976 40.8428 68.749 40.6681C68.6395 40.2745 68.4074 39.926 68.0864 39.6733C67.7654 39.4205 67.3723 39.2766 66.964 39.2624C66.6973 39.2531 66.4333 39.2995 66.1881 39.3968C65.9713 39.4829 65.9221 39.7507 66.0534 39.9436C66.1847 40.1365 66.4491 40.1764 66.6775 40.1288C66.7615 40.1113 66.8478 40.1037 66.9346 40.1068C67.1634 40.1147 67.3838 40.1954 67.5637 40.337C67.7436 40.4787 67.8736 40.674 67.935 40.8946C67.949 40.9448 67.9592 40.9957 67.9657 41.047C67.9973 41.2945 68.1808 41.5534 68.4301 41.544Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M57.229 45.2907C57.229 46.1661 57.9407 46.872 58.8232 46.872C60.1562 46.872 62.2757 44.1508 62.2757 42.9925C62.2757 41.1391 59.959 38.5421 58.8232 38.5421C57.9407 38.5421 57.229 39.248 57.229 40.1234V45.2907Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 0.554047
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7358 41.544C60.9783 41.5348 61.1326 41.2844 61.1156 41.0423C61.1087 40.9446 61.1032 40.8428 61.0546 40.6681C60.9451 40.2745 60.713 39.926 60.3921 39.6733C60.0711 39.4205 59.6779 39.2766 59.2696 39.2624C59.003 39.2531 58.739 39.2995 58.4938 39.3968C58.2769 39.4829 58.2278 39.7507 58.3591 39.9436C58.4903 40.1365 58.7547 40.1764 58.9831 40.1288C59.0672 40.1113 59.1535 40.1037 59.2403 40.1068C59.4691 40.1147 59.6895 40.1954 59.8693 40.337C60.0492 40.4787 60.1793 40.674 60.2406 40.8946C60.2546 40.9448 60.2649 40.9957 60.2714 41.047C60.303 41.2945 60.4864 41.5534 60.7358 41.544Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6256 45.0085C35.6256 48.6228 35.4548 51.5312 32.9781 51.5312C30.5014 51.5312 27.8823 49.2722 27.8823 45.6579C27.8823 42.0436 30.5299 38.4575 32.9781 38.4575C35.4264 38.4575 35.6256 41.3941 35.6256 45.0085Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 2.21619,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.5311 63.628L63.3231 64.9027C62.9314 65.1289 62.4419 64.8462 62.4419 64.394V61.7475C62.4419 61.2953 62.9314 61.0126 63.3231 61.2388L65.5311 62.5135V61.7475C65.5311 61.2953 66.0206 61.0126 66.4123 61.2388L68.6198 62.5133V61.7475C68.6198 61.2953 69.1093 61.0126 69.5009 61.2388L71.7929 62.562C72.1845 62.7881 72.1845 63.3534 71.7929 63.5795L69.5009 64.9027C69.1093 65.1289 68.6198 64.8462 68.6198 64.394V63.6282L66.4123 64.9027C66.0206 65.1289 65.5311 64.8462 65.5311 64.394V63.628Z",
    fill: "#1E1E1E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSketchpadThumbnail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/SketchpadThumbnail.714ce952fb31b24c5520fa0a1c7c6bad.svg";